module.exports = __webpack_public_path__ + "img/side_search.dec36318.png";